import { FC } from 'react';
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
} from '@chakra-ui/react';
import { AddIconButton } from 'components/atoms/AddIconButton';
import { MinusIconButton } from 'components/atoms/MinusIconButton';
import { EditHookReturnType } from '../../../types';
import { PlaneTextInput } from '../../../../Forms';

type Props = EditHookReturnType['form'] & {
  mode: '登録' | '更新';
  handleConfirm: () => void;
  onOpenModalDelete: () => void;
  onAppend: () => void;
  onRemove: (index: number) => void;
  controlledFields: { value: string; id: string }[];
};

export const ComponentRegistrationInputModalView: FC<Props> = ({
  mode,
  register,
  formState,
  handleConfirm,
  onOpenModalDelete,
  onAppend,
  onRemove,
  controlledFields,
}) => (
  <ModalContent maxHeight="90vh">
    <ModalHeader p="40px">コンポーネントの{mode}</ModalHeader>
    <ModalCloseButton />
    <ModalBody overflowY="auto" px="40px">
      <Stack spacing="6" direction="column">
        <FormControl isRequired isInvalid={!!formState.errors.componentName}>
          <FormLabel>コンポーネント名</FormLabel>
          <PlaneTextInput name="componentName" register={register} />
          <FormErrorMessage>
            {formState.errors.componentName?.message}
          </FormErrorMessage>
        </FormControl>
        <FormLabel>顧客環境に適用したい情報の定義</FormLabel>
        <Stack pl="5">
          <FormControl isRequired isInvalid={!!formState.errors.repositoryUrl}>
            <FormLabel>管理場所</FormLabel>
            <PlaneTextInput name="repositoryUrl" register={register} />
            <FormErrorMessage>
              {formState.errors.repositoryUrl?.message}
            </FormErrorMessage>
          </FormControl>
        </Stack>
        <FormLabel>顧客環境から収集したい情報の定義</FormLabel>
        <Stack pl="5">
          <FormControl isRequired isInvalid={!!formState.errors.manifestName}>
            <FormLabel>マニフェストファイル名</FormLabel>
            <PlaneTextInput name="manifestName" register={register} />
            <FormErrorMessage>
              {formState.errors.manifestName?.message}
            </FormErrorMessage>
          </FormControl>
          <FormControl isRequired isInvalid={!!formState.errors.targetKeys}>
            <FormLabel>必要なキー</FormLabel>
            {controlledFields.map((field, index) => (
              <Stack key={field.id} p={2}>
                <HStack>
                  <PlaneTextInput
                    name={`targetKeys.${index}.value`}
                    register={register}
                  />
                  {controlledFields.length > 1 && (
                    <MinusIconButton label="" onClick={() => onRemove(index)} />
                  )}
                </HStack>
                <Stack>
                  <FormErrorMessage>
                    {formState.errors.targetKeys?.[index]?.value?.message}
                  </FormErrorMessage>
                </Stack>
              </Stack>
            ))}
          </FormControl>
          {/* 必要なキーの追加 */}
          <Stack>
            {controlledFields.length < 3 && (
              <AddIconButton label="" onClick={onAppend} />
            )}
          </Stack>
        </Stack>
      </Stack>
    </ModalBody>
    <ModalFooter justifyContent="center" p="40px">
      <Stack alignItems="center" spacing="24px">
        <Button
          w="140px"
          colorScheme="blackAlpha"
          onClick={handleConfirm}
          isDisabled={!formState.isValid}
        >
          確認
        </Button>
        {mode === '更新' && (
          <Button
            variant="link"
            colorScheme="blackAlpha"
            onClick={onOpenModalDelete}
          >
            このコンポーネントを削除
          </Button>
        )}
      </Stack>
    </ModalFooter>
  </ModalContent>
);
